import './BaseLayout.css';
import React from 'react';

import Switcher from '../Switcher';
import AppHeader from '@views/AppHeader';
import { BaseMetas } from '@views/Metas';
import Onboarding from '@views/Onboarding';
import config from '@config';
import { Layout } from 'antd';
const { Content, Header } = Layout;

const BaseLayout = () => (
  <Layout className="BaseLayout">
    <Onboarding />
    <Header theme="light" className="BaseLayout-header">
      <AppHeader />
    </Header>
    <Layout
      className="BaseLayout-content"
      style={{
        backgroundImage: `url("${config.basePath}/img/bg-pattern.png")`,
      }}
    >
      <Content>
        <BaseMetas />
        <Switcher />
      </Content>
    </Layout>
  </Layout>
);

BaseLayout.displayName = 'BaseLayout';

export default BaseLayout;
